import styled, { css } from 'styled-components';
import { Button } from 'antd';
import { Title } from '@/components/Typography';

export const TitleWrapper = styled(Title)`
	${({ theme }) => css`
		${{ ...theme.fonts.heading.md }}
	`}
`;

export const ButtonWrapper = styled(Button)`
	display: flex;
	align-items: center;
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	background: ${({ theme }) => theme.palette.primary.default};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	span:first-child {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_lg};
		margin-top: 3px;
	}
`;
